import styled from 'styled-components';
import { breakpoints } from 'themes/helpers';

export const Wrapper = styled.footer`
  font-size: ${({ theme }) => theme.fontSize[1]}px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.neutral.neutral75};
  width: 100%;
  max-width: 279px;
  margin: 0 auto;
  text-align: center;
  @media (min-width: ${() => breakpoints.tablet}px) {
    padding-top: ${({ theme }) => theme.space(4)}px;
    padding-bottom: ${({ theme }) => theme.space(10)}px;
  }
`;

export const Top = styled.div`
  margin-bottom: 16px;
`;

export const Debug = styled.p`
  font-weight: 700;
`;

export const Version = styled.p`
  font-weight: 700;
  margin-top: ${({ theme }) => theme.space(4)}px;
`;

export const SuccessFont = styled.span`
  color: ${({ theme }) => theme.palette.system.verified.main};
`;

export const ErrorFont = styled.span`
  color: ${({ theme }) => theme.palette.system.alert.main};
`;
